import { FastlyImage } from '@components/common/image'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { SizeType } from '@components/atoms/button'
import { Trans } from '@lingui/macro'
import classNames from 'classnames'

type Props = {
  title?: string
  isCoursePage?: boolean
  urlQuery?: string
  ctaSize?: SizeType
  shouldScrollToTop?: boolean
  isCodingCampPage?: boolean
  hideCta?: boolean
}

export const Investors = ({
  title,
  isCoursePage,
  urlQuery,
  ctaSize,
  shouldScrollToTop,
  isCodingCampPage,
  hideCta,
}: Props) => {
  const PATH = '/images/book-trial-class-jp'
  const investors = [
    {
      name: 'Y Combinator',
      imageName: 'yc',
      width: 225,
      height: 94,
    },
    {
      name: 'Rebright Partners',
      imageName: 'rb',
      width: 225,
      height: 94,
    },
    {
      name: 'GSF',
      imageName: 'gsf',
      width: 158,
      height: 56,
    },
    {
      name: 'Java Capital',
      imageName: 'java-capital',
      width: 302,
      height: 38,
    },
    {
      name: 'Nurture Ventures',
      imageName: 'nurture-ventures',
      width: 258,
      height: 51,
    },
    {
      name: 'DayOne|Syndicate',
      imageName: 'day-one',
      width: 289,
      height: 44,
    },
    {
      name: 'WeFunder',
      imageName: 'wefunder',
      width: 187,
      height: 80,
    },
    {
      name: 'MS & AD',
      imageName: 'ms',
      width: 225,
      height: 94,
    },
  ]
  return (
    <div className="relative">
      <div className="container mx-auto">
        <div
          className={`flex flex-col relative py-12 lg:py-16 rounded-2xl ${
            !isCoursePage && 'items-center'
          }`}
        >
          <h2
            className={classNames('text-grey font-600', {
              'text-2xl text-left leading-tight': isCoursePage,
              'text-2xl leading-tight text-center lg:text-4xl': !isCoursePage,
            })}
          >
            {title ? (
              <>{title}</>
            ) : (
              <Trans>Codingal is backed by esteemed angel investors</Trans>
            )}
          </h2>
          <p
            className={`pt-3 ${
              isCoursePage
                ? 'lg:text-lg text-left'
                : isCodingCampPage
                ? 'text-lg text-center'
                : 'text-lg text-center px-4'
            }`}
          >
            <Trans>
              Codingal has secured substantial backing from renowned investment
              firms and a host of prominent angel investors.
            </Trans>
          </p>
          <div className="mt-5 w-full md:w-auto">
            <div
              className={`flex flex-wrap items-center justify-center md:gap-3 gap-2 my-3 md:pt-0 w-full md:w-auto ${
                isCoursePage ? '' : 'p-4 md:p-10'
              }`}
            >
              {investors.map(({ imageName, name, height, width }) => (
                <div key={name} className="max-w-2/6">
                  <FastlyImage
                    src={`${PATH}/${imageName}.png`}
                    webpSrc={`${PATH}/${imageName}.webp`}
                    alt={name}
                    height={height}
                    width={width}
                  />
                </div>
              ))}
            </div>
          </div>
          {!isCodingCampPage && !hideCta && (
            <>
              {!isCoursePage && (
                <div className="w-full flex justify-center px-5">
                  <BookFreeClassBtn
                    className="w-full"
                    shouldScrollToTop={shouldScrollToTop}
                    size={ctaSize}
                    query={urlQuery}
                  />
                </div>
              )}
              {isCoursePage && (
                <div className="mx-auto w-full md:max-w-xs text-center mt-5">
                  <BookFreeClassBtn query={urlQuery} size={ctaSize} />
                </div>
              )}
            </>
          )}

          {isCodingCampPage && (
            <div className="flex justify-center pt-8 w-full px-5 mx-auto">
              {' '}
              <a
                className="text-center btn btn-orange w-full md:w-auto py-3 text-lg"
                href="#courses"
              >
                Claim your spot now
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
